export const toExclude = /chrome-extension:\/\/|moz-extension:\/\//;
